"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setProperties = setProperties;
exports.addCase = addCase;
exports.deleteCase = deleteCase;
exports.calculate = calculate;
exports.parseResult = parseResult;
function setProperties(id, pvs) {
    return {
        type: "oilon-tool/SET-PROPERTIES",
        id: id,
        pvs: pvs
    };
}
function addCase() {
    return {
        type: "oilon-tool/ADD-CASE"
    };
}
function deleteCase(id) {
    return {
        type: "oilon-tool/DELETE-CASE",
        id: id
    };
}
function calculate() {
    return {
        type: "oilon-tool/CALCULATE"
    };
}
function parseResult(result) {
    return {
        type: "oilon-tool/PARSE-RESULT",
        result: result
    };
}
//# sourceMappingURL=actions.js.map